import React from 'react';
import Faqs from 'src/components/Faqs/Faqs';
import LoadState from 'src/components/LoadState/LoadState';
import useFaqSearch, {
  UseFaqSearchReturn,
} from 'src/components/Faqs/CustomHooks/useFaqSearch';
import useFaqForm, {
  UseFaqFormReturn,
} from 'src/components/Faqs/CustomHooks/useFaqForm';
import { FaqDocument } from 'src/components/Faqs/types';
import { FaqFormData } from 'src/components/Faqs/CustomHooks/useFaqForm';

export interface AssetFaqOperations {
  faqs: FaqDocument[];
  isLoadingFaqs: boolean;
  saveFaq: (faq: FaqFormData, action: any) => Promise<void>;
  deleteFaq: (faq: any) => Promise<void>;
  isSaving: boolean;
  validationStatus: any;
  lastSaveAction: any;
  resetValidation: () => void;
}

interface AssetFaqsProps {
  asset: any;
  faqOperations: AssetFaqOperations;
}

const AssetFaqs = ({ asset, faqOperations }: AssetFaqsProps) => {
  const {
    faqs,
    isLoadingFaqs,
    saveFaq,
    deleteFaq,
    isSaving,
    validationStatus,
    lastSaveAction,
    resetValidation,
  }: AssetFaqOperations = faqOperations;

  const { filteredFaqs, onSearch, searchQuery }: UseFaqSearchReturn =
    useFaqSearch(faqs);

  const {
    formData,
    setFormData,
    isEditing,
    showOverlay,
    openForm,
    closeForm,
    openFormForEdit,
  }: UseFaqFormReturn = useFaqForm({
    validationStatus,
    lastSaveAction,
    onValidationSuccess: resetValidation,
  });

  return (
    <LoadState isLoading={isLoadingFaqs}>
      <Faqs
        faqs={filteredFaqs}
        onSearch={onSearch}
        searchQuery={searchQuery}
        onDeleteFaq={deleteFaq}
        formData={formData}
        setFormData={setFormData}
        isEditing={isEditing}
        showOverlay={showOverlay}
        onOpenForm={openForm}
        onCloseForm={closeForm}
        onEditFaq={openFormForEdit}
        onSaveFaq={saveFaq}
        isSaving={isSaving}
      />
    </LoadState>
  );
};

export default AssetFaqs;